export default "__VITE_ASSET__1c0fc56d__"